import React, { PropTypes } from 'react';

const  Card = ({ children, className }) => {
    return (
        <div className={`card${className ? ` ${className}` : ''}`}>
            {children}
        </div>
    );
};

Card.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};

export default Card;


/** WEBPACK FOOTER **
 ** ./src/components/bootstrap/Card.js
 **/